import ApplicationSerializer from 'eflex/serializers/application';

export default class JemProcessDatumSerializer extends ApplicationSerializer {
  attrs = {
    buildStatusChild: {
      serialize: false,
      deserialize: false,
    },
  };
}
